import { render, staticRenderFns } from "./ScopeOption.vue?vue&type=template&id=5136eeff&scoped=true"
import script from "./ScopeOption.vue?vue&type=script&lang=js"
export * from "./ScopeOption.vue?vue&type=script&lang=js"
import style0 from "./ScopeOption.vue?vue&type=style&index=0&id=5136eeff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5136eeff",
  null
  
)

export default component.exports